import React, { useRef, useState } from "react";
import "./style.less";

function Books() {

    const $book = useRef();
    const [open, setOpen] = useState(false);

    const [top, setTop] = useState();
    const [left, setLeft] = useState();

    const onOpenBook = () => {
        if (!open) {
            setTop($book.current.getBoundingClientRect().top)
            setLeft($book.current.getBoundingClientRect().left)
        }

        setOpen(!open)
    }

    return (
        <div className={`book ${open && "book--open"} center`}
            style={open ? { transform: `translateZ(500px) translateX(calc(${-left}px + 50vw)) translateY(calc(${-top}px + 50vh)) rotateY(-90deg)` } : {}}
            ref={$book}
            onClick={onOpenBook}>
            <div className="book-back"></div>
            <div className="book-center">
                <p>你不知道的 JavaScript 上卷</p>
                <div className="head"></div>
            </div>
            <div className="book-cover"></div>
        </div>
    )
}

export default Books;